import { supabase } from './supabase.js';
import { formatPartnerPlaceLabel } from './listingPartnerLogisticsService.js';

export { formatPartnerPlaceLabel };

export async function fetchPickupPointsForCheckout(listingId, buyerDeliveryMode = null) {
  const lid = String(listingId ?? '').trim();
  if (!lid) return { points: [], error: 'missing_listing' };
  const params = { p_listing_id: lid };
  if (buyerDeliveryMode) params.p_buyer_delivery_mode = String(buyerDeliveryMode).trim();
  const { data, error } = await supabase.rpc('list_pickup_points_for_checkout', params);
  if (error) {
    console.error('[pickupPointsService]', error.message);
    return { points: [], error: error.message };
  }
  return { points: Array.isArray(data) ? data : [], error: null };
}
